import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-produce-task-inspecting",
  "use": "icon-produce-task-inspecting-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-produce-task-inspecting\"><path fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" d=\"M5.5 21a4.5 4.5 0 1 0 0-9a4.5 4.5 0 0 0 0 9ZM1 16V6.5A4.5 4.5 0 0 1 5.5 2H6m17 14V6.5A4.5 4.5 0 0 0 18.5 2H18m.5 19a4.5 4.5 0 1 0 0-9a4.5 4.5 0 0 0 0 9ZM10 17s0-2 2-2s2 2 2 2\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol